<template>
  <b-form-group
    :label='label'>
    <b-form-select
      :name='name'
      :options='listaCargos'
      v-model='valor' />
  </b-form-group>
</template>

<script>
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select'
import InputBaseMixins from './mixins/InputBaseMixins'

export default {
  name: 'InputCargo',
  mixins: [InputBaseMixins],
  components: {
    bFormGroup,
    bFormSelect,
  },
  data() {
    return {
      listaCargos: [
        { value: 'administrador', text: 'Administrador' },
        { value: 'lider', text: 'Lider' },
        { value: 'atendente', text: 'Atendente' },
        { value: 'barbeiro', text: 'Barbeiro' },
        { value: 'barbeiro_caixa', text: 'Barbeiro caixa' },
      ],
    }
  },
}

</script>
